$(document).on "turbolinks:load", ->
  # Only need this functionality on calendar
  if $("#courseware-calendar").length > 0
    # get parameters from URL
    params = new URLSearchParams(window.location.search)
    if params.has('assignment_id')
      # get assignment_id
      id = params.get('assignment_id')
      # trigger popover
      $("#calendar-entry-" + id).show()

      $("#calendar-next").attr('href', $("#calendar-next").attr('href').replace(/&?assignment_id=([^&]$|[^&]*)/i, ""))
      $("#calendar-previous").attr('href', $("#calendar-previous").attr('href').replace(/&?assignment_id=([^&]$|[^&]*)/i, ""))